import React from 'react';
import { ActivityIndicator, TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

import { Text } from '@/components/ui/text';
import { WebAppShell } from '@/design-system/components';
import { COLORS, profileWebStyles } from '../profileStyles';
import type { Translate } from '../profileTypes';

interface ProfileShellStateProps {
  kind: 'loading' | 'error';
  onRetry: () => void;
  t: Translate;
}

/** Full-page loading / load-failed state inside the app shell. */
export function ProfileShellState({ kind, onRetry, t }: ProfileShellStateProps) {
  return (
    <WebAppShell active="profile" contentMaxWidth="100%">
      <View style={profileWebStyles.stateCard}>
        {kind === 'loading' ? (
          <ActivityIndicator size="large" color={COLORS.primary} />
        ) : (
          <View style={profileWebStyles.stateIconDanger}>
            <MaterialIcons name="error-outline" size={32} color={COLORS.error} />
          </View>
        )}
        <Text style={profileWebStyles.stateTitle}>
          {kind === 'loading' ? t('profile.loading') : t('profile.failedToLoad')}
        </Text>
        {kind === 'error' && (
          <TouchableOpacity style={profileWebStyles.stateButton} onPress={onRetry} accessibilityRole="button">
            <Text style={profileWebStyles.stateButtonText}>{t('profile.retry')}</Text>
          </TouchableOpacity>
        )}
      </View>
    </WebAppShell>
  );
}
